<template>
    <div class="spinner"></div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
.spinner {
  width: 15px;
  height: 15px;
  // margin: 1px;
  border-radius: 50%;
  border: 3px solid rgb(0, 95, 219);
  border-color: rgb(0, 95, 219) transparent rgb(0, 95, 219) transparent;
  animation: spinner 1.2s linear infinite;
}
@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
